import { getDocumentArchive } from "./documentArchiveService";

// The server refreshes its own listing every 30 minutes; matching that here
// means opening Sourcebooks and eBrochures back to back costs one request each.
const ARCHIVE_STALE_MS = 30 * 60 * 1000;

// Shared by the archive pages and their route loaders, so both land on one
// cache entry.
export const documentArchiveQuery = (type) => ({
  queryKey: ["documentArchive", type],
  queryFn: () => getDocumentArchive(type),
  staleTime: ARCHIVE_STALE_MS,
});
